import React from 'react';
import { GraduationCap } from 'lucide-react';
import PortalLoginShell from './PortalLoginShell';

export default function StudentLogin() {
  return (
    <PortalLoginShell
      badge="For Students"
      title="Student Login"
      subtitle="Track your application status, see assigned colleges, and follow next steps."
      expectedRole="student"
      onSuccessPath="/student-portal"
      iconBg="bg-tge-gold"
      Icon={GraduationCap}
      emailPlaceholder="you@email.com"
      testidPrefix="student-login"
      footerLink={{
        label: 'New here?',
        cta: 'Contact us to get started',
        path: '/contact',
      }}
    />
  );
}
